import { useState, useEffect } from 'react';

function getWindowDimensions() {
  if (typeof window === 'undefined') {
    return { width: 0, height: 0 }; // Provide a safe fallback for SSR
  }
  return { width: window.innerWidth, height: window.innerHeight };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    // Set dimensions when the component mounts
    setWindowDimensions(getWindowDimensions());

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Prevent rendering on the server
  if (windowDimensions === null) return 'loading';

  const screenWidth: number = windowDimensions.width;

  if (screenWidth < 768) {
    return 'mobile';
  } else if (screenWidth >= 768 && screenWidth < 1024) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}
